/**
 * Reference manifest for the Gantt milestone marker.
 *
 * Epic SP-A (#1386) replaces the rounded-rect scaffold renderer with a
 * diamond (or dated flag) that sits on the timeline. Milestones have no
 * duration — they're zero-width gates.
 */

import { createPlanningManifest, type PlanningNodeProps } from '../manifest-base';

export const GanttMilestoneManifest = createPlanningManifest({
  id: 'gantt_milestone',
  domain: 'gantt',
  label: 'Milestone',
  accent: '#f59e0b',
  icon: 'flag',
  defaultWidth: 48,
  defaultHeight: 48,
});

export type GanttMilestoneProps = PlanningNodeProps;
